"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FileReviewPopupErrors = (props) => {
    const { numComplete, numErrors } = props;
    return (react_1.default.createElement("div", { className: 'info-head' },
        react_1.default.createElement("h3", null, "You're almost done!"),
        react_1.default.createElement("p", null,
            "You have",
            numComplete ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", { className: 'bold' },
                    " ",
                    numComplete),
                "work",
                numComplete === 1 ? ' ' : 's ',
                "that ",
                numComplete === 1 ? 'is' : 'are',
                " ready to submit and",
                ' ')) : null,
            react_1.default.createElement("span", { className: 'bold' },
                " ",
                numErrors,
                " "),
            "work",
            numErrors === 1 ? '' : 's',
            " ",
            numComplete ? '' : 'that ',
            "still need",
            numErrors === 1 ? 's' : '',
            " attention. Please review and resolve errors in order to submit all your works.")));
};
exports.default = FileReviewPopupErrors;
